module.exports = __webpack_public_path__ + "img/rubico_cover.5e2aedfe.png";